import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { CoverageZonesApiAdapter } from '../adapters/CoverageZonesApiAdapter';
import { Service } from '../services/Service';

interface UseCoverageRulesOptions {
    serviceId: number;
    enabled?: boolean;
}

export const useCoverageRules = ({ serviceId, enabled = true }: UseCoverageRulesOptions) => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new CoverageZonesApiAdapter(httpClient);
    const service = new Service(apiAdapter);

    const { data, isLoading, error, refetch, isPending } = useQuery({
        queryKey: ['coverage-rules', serviceId],
        queryFn: () => service.getCoverageRules(serviceId),
        enabled: enabled && !!serviceId,
        staleTime: 5 * 60 * 1000, // 5 minutos
    });

    return {
        rules: data?.rules ?? [],
        serviceInfo: data ? {
            service_id: data.service_id,
            service_code: data.service_code,
            service_description: data.service_description,
        } : null,
        isLoading: isLoading || isPending,
        error,
        refetch,
        total: data?.rules?.length ?? 0,
    };
};

